import { useParams } from "react-router-dom";
import ListYourShowForm from "../../../listYourShow/ListYourShowForm.jsx";

/**
 * Admin / superadmin edit uses the same multi-step create flow.
 * Superadmin also gets GST + Premium / Booking Open / Active on the Additional info step.
 */
export default function AdminEventEdit() {
  const { id } = useParams();
  return (
    <ListYourShowForm
      eventId={id}
      successRedirect="/admin/events"
      exitTo="/admin/events"
      adminPublishControls
    />
  );
}
